export default "__VITE_ASSET__C1mnnC5I__"